import ServiceBase from '../ServiceBase';
import dividendAnalysisProxy from '../../proxies/fundamental/DividendAnalaysisProxy';
import lastPriceProxy from '../../proxies/common/LastPriceProxy';

class DividendAnalysisService extends ServiceBase {
  GetAnalysis(params, source) {
    return this.applyMemoryCache('DividendAnalysisService.GetAnalysis', params)(
      () => dividendAnalysisProxy.GetAnalysis(params, source),
    );
  }

  getLastPriceData(params, source) {
    return this.applyMemoryCache(
      'DividendAnalysisService.GetLatestPrice',
      params,
    )(() => lastPriceProxy.GetLatestPrice(params, source));
  }

  ExportData(params) {
    return this.applyMemoryCache('DividendAnalysisService.ExportData', params)(
      () => dividendAnalysisProxy.ExportData(params),
    );
  }
}

const dividendAnalysisService = new DividendAnalysisService();
export default dividendAnalysisService;
